import { FC } from 'react';
import { Table, TableBody, TableContainer } from '@mui/material';
import { AffiliateHeader } from './AffiliateHeader';

interface Props {
  children?: JSX.Element | JSX.Element[] | string | undefined | null;
  emptyElement: JSX.Element | JSX.Element[] | string | undefined | null;
}

export const AffiliateTable: FC<Props> = ({ children, emptyElement }) => {
  const hasRows = Array.isArray(children) && children.length > 0;

  return (
    <TableContainer>
      <Table sx={{ minWidth: 450 }} aria-label="simple table">
        <AffiliateHeader />
        {hasRows && <TableBody>{children}</TableBody>}
      </Table>
      {!hasRows && emptyElement}
    </TableContainer>
  );
};
